// extracted by mini-css-extract-plugin
module.exports = {"ellipse":"Ellipse_ellipse__71Z8h"};